<script lang="ts" setup>
    import { onMounted, ref } from 'vue';
    import AppForm from '@/pages/core/form/AppForm.vue';
    import i18n from '@/plugins/i18n';
    import { userService } from '@/services/userService';

    const t = i18n.global.t;

    const dialogChangePassword = ref<boolean>(false);
    const loading = ref<boolean>(false);
    const changePasswordFormRef = ref<any>(null);

    const password = ref<string | null>(null);
    const newPassword = ref<string | null>(null);
    const confirmPassword = ref<string | null>(null);

    const rules = {
        password: [(v: string) => !!v || t('rules.required')],
        newPassword: [(v: string) => !!v || t('rules.required')],
        confirmPassword: [
            (v: string) => !!v || t('rules.required'),
            (v: string) => {
                if (v && newPassword.value) {
                    return v !== newPassword.value ? t('rules.newPasswordDoesNotMatch') : true;
                }
                return true;
            },
        ],
    };

    const open = (): void => {
        dialogChangePassword.value = true;

        // nextTick(() => {
        //     if (changePasswordFormRef.value.$refs.form) {
        //         changePasswordFormRef.value.$refs.form.reset();
        //         changePasswordFormRef.value.$refs.form.resetValidation();
        //     }
        // });
    };

    defineExpose({ open });

    const changePassword = async (): Promise<void> => {
        const validateResult = await changePasswordFormRef.value.$refs.form.validate();
        if (validateResult.valid) {
            loading.value = true;

            const params = {
                password: password.value!,
                newPassword: newPassword.value!,
                newPassword_confirmation: confirmPassword.value!,
            };

            userService
                .changePassword(params)
                .then((response: any) => {
                    if (response.data.success) {
                        password.value = '';
                        newPassword.value = '';
                        confirmPassword.value = '';
                        dialogChangePassword.value = false;
                    }
                })
                .finally(() => {
                    loading.value = false;
                });
        }
    };

    onMounted((): void => {
        console.log('Component app-menuAccountChangePasswordDialog mounted.');
    });
</script>
<template>
    <v-dialog v-model="dialogChangePassword" width="350" :scrim="false">
        <v-card class="pa-3 pass-dialog">
            <v-card-title class="py-1 pl-3 pr-1 d-flex justify-space-between align-center" style="height: 48px">
                <span class="text-h5">{{ t('menu.changePassword') }}</span>
                <v-btn density="default" tag="a" :icon="mdiClose" @click="dialogChangePassword = false" variant="text" size="36" />
            </v-card-title>
            <AppForm ref="changePasswordFormRef" @keyup.enter="changePassword" class="pl-1 pr-2">
                <v-card-text class="py-0 pr-2">
                    <v-container class="pl-0 pr-0">
                        <v-row>
                            <v-col cols="12" class="pl-2 pr-2 pt-0 pb-0">
                                <!--                                [DOM] Password forms should have (optionally hidden) username fields for accessibility-->
                                <input type="text" name="username" autocomplete="username" hidden />
                                <v-text-field
                                    density="compact"
                                    type="password"
                                    variant="underlined"
                                    :label="t('menu.currentPassword')"
                                    v-model="password"
                                    :rules="rules.password"
                                    autocomplete="current-password"
                                    color="grey"
                                    class="pt-0 pb-0"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="pl-2 pr-2 pt-0 pb-0">
                                <v-text-field
                                    density="compact"
                                    type="password"
                                    variant="underlined"
                                    :label="t('menu.password')"
                                    v-model="newPassword"
                                    :rules="rules.newPassword"
                                    autocomplete="new-password"
                                    color="grey"
                                    class="pt-0 pb-0"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="pl-2 pr-2 pt-0 pb-0">
                                <v-text-field
                                    density="compact"
                                    type="password"
                                    variant="underlined"
                                    :label="t('menu.confirmPassword')"
                                    v-model="confirmPassword"
                                    :rules="rules.confirmPassword"
                                    autocomplete="new-password"
                                    color="grey"
                                    class="pt-0 pb-0"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </AppForm>
            <v-card-actions class="pb-0 pl-0 pr-2">
                <v-spacer></v-spacer>
                <v-btn tag="a" :loading="loading" :disabled="loading" density="default" variant="flat" color="tbGreen" style="color: white" elevation="0" @click="changePassword">
                    {{ t('action.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped>
    .v-theme--dark .v-card.pass-dialog {
        border: 1px solid #404148;
    }
</style>
